// extracted by mini-css-extract-plugin
export default {"logoUploadModal":"logo-upload-modal_logoUploadModal__yQwI6","uploadZone":"logo-upload-modal_uploadZone__l4-kP"};